import { CandyThunkAction } from "../Store/CandyReduxTypes";

import { ModalOptions, ModalStateInfo } from "./IModalState";

export enum ModalStateActionType {
    ShowModal = "SHOW_MODAL",
    CloseModal = "CLOSE_MODAL",
}

export interface ShowModalAction {
    type: ModalStateActionType.ShowModal;
    payload: ModalStateInfo;
}

export interface HideModalAction {
    type: ModalStateActionType.CloseModal;
}

export function showModalActionCreator(options: ModalOptions): ShowModalAction {
    return { type: ModalStateActionType.ShowModal, payload: { ...options, isOpen: true } };
}

export function hideModalActionCreator(): HideModalAction {
    return { type: ModalStateActionType.CloseModal };
}

export function showModalCandyDispatchActionCreator(options: ModalOptions): CandyThunkAction {
    return (_, __, form) => {
        form.showCustomModal(options);
    };
}

export type FormModalStateAction = ShowModalAction | HideModalAction;
